import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface NavigationItem {
  name: string;
  href: string;
}
interface SubsidiaryHeaderProps {
  name: string;
  color: string;
  navigation: NavigationItem[];
  logo?: string;
}
export function SubsidiaryHeader({
  name,
  color,
  navigation,
  logo
}: SubsidiaryHeaderProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className={`sticky top-0 z-50 ${color} shadow-sm`} data-id="element-349">
      <div className="container mx-auto px-4 py-4" data-id="element-350">
        <div className="flex items-center justify-between" data-id="element-351">
          <Link to="/" className="flex items-center space-x-4" data-id="element-352">
            {logo ? <div className="flex items-center" data-id="element-353">
                <img src={logo} alt={`${name} Logo`} className="h-12 w-auto object-contain" data-id="element-354" />
              </div> : <span className="text-xl font-bold" data-id="element-355">{name}</span>}
          </Link>
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-6" data-id="element-356">
            {navigation.map(item => <a key={item.name} href={item.href} className="font-medium hover:opacity-80 transition-opacity" data-id="element-357">
                {item.name}
              </a>)}
            <Link to="/" className="px-4 py-2 bg-white/10 rounded-md font-medium hover:bg-white/20 transition-colors" data-id="element-358">
              Back to Main Site
            </Link>
          </nav>
          {/* Mobile Menu Button */}
          <button className="md:hidden p-2" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-359">
            {isMenuOpen ? <X size={24} data-id="element-360" /> : <Menu size={24} data-id="element-361" />}
          </button>
        </div>
        {/* Mobile Navigation */}
        <AnimatePresence data-id="element-362">
          {isMenuOpen && <motion.div className="md:hidden mt-4" initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.3
        }} data-id="element-363">
              <nav className="flex flex-col space-y-4 pb-4" data-id="element-364">
                {navigation.map(item => <a key={item.name} href={item.href} className="font-medium hover:opacity-80 transition-opacity" onClick={() => setIsMenuOpen(false)} data-id="element-365">
                    {item.name}
                  </a>)}
                <Link to="/" className="px-4 py-2 bg-white/10 rounded-md font-medium hover:bg-white/20 transition-colors text-center" data-id="element-366">
                  Back to Main Site
                </Link>
              </nav>
            </motion.div>}
        </AnimatePresence>
      </div>
    </header>;
}